import { Subject, Subscription } from 'rxjs';
import * as moment from 'moment';
import { Base, Company, Report } from '@akiba/models_beta_temp';
import { IPaginatorResult } from './interfaces';

export class LocalHelpers {

  static unsubscribe(subscription: Subscription | Subject<any> | undefined): void {
    if (subscription && subscription.closed === false) {
      subscription.unsubscribe();
    }
  }

  static chunk(array: Array<any>, size: number): Array<Array<any>> {

    const copy = JSON.parse(JSON.stringify(array));
    if (!copy.length) {
      return [];
    }

    if (copy.length <= size) {
      return new Array<Array<any>>(copy);
    }

    const loops = Math.ceil(copy.length / size);
    const chunk: Array<Array<any>> = new Array();
    for (let index = 0; index < loops; index++) {
      chunk.push(copy.splice(0, size));
    }

    return chunk;

  }

  static parseStringDate(date: string, format: string | string[], locale: string = 'en-us'): Date | undefined {

    const aMoment = moment(date, format, locale, true);
    if (aMoment.isValid()) {
      return aMoment.toDate();
    }

    return undefined;

  }

  static sortCompany(a: Company, b: Company): number {

    if (a.companyName.toLowerCase() < b.companyName.toLowerCase()) {
      return -1;
    } else if (a.companyName.toLowerCase() > b.companyName.toLowerCase()) {
      return 1;
    } else {
      return 0;
    }

  }

  static randomColor(): string {

    const letters = '0123456789ABCDEF'.split('');
    let color = '#';
    for (let i = 0; i < 6; i++) {
      color += letters[Math.floor(Math.random() * 16)];
    }

    return color;

  }

  static getWeekOfYear(date: Date): { week: number, year: number } {

    const FIRST_MONTH_OF_THE_YEAR = 0;
    const FIRST_DAY_OF_THE_MONTH = 1;
    const DAYS_IN_A_WEEK = 7;
    const THURSDAY_DAY_OF_THE_WEEK = 4;
    const SUNDAY_DAY_OF_THE_WEEK = 7;
    const TEN_DAYS_MILISECONDS = 86400000;


    const dateUTC = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()));

    const nearestThursday = new Date(Date.UTC(
      dateUTC.getFullYear(),
      dateUTC.getMonth(),
      dateUTC.getDate() + THURSDAY_DAY_OF_THE_WEEK - (dateUTC.getUTCDay() || SUNDAY_DAY_OF_THE_WEEK)
    ));

    const firstDayOfYear = new Date(Date.UTC(
      nearestThursday.getFullYear(),
      FIRST_MONTH_OF_THE_YEAR,
      FIRST_DAY_OF_THE_MONTH
    ));

    const weekNumber = Math.ceil(
      (((nearestThursday.getTime() - firstDayOfYear.getTime()) / TEN_DAYS_MILISECONDS) + 1) / DAYS_IN_A_WEEK
    );

    return {
      week: weekNumber,
      year: nearestThursday.getUTCFullYear()
    };
  }

  static arrayPaginator(items: Array<any>, currentPage: number, itemsPerPage: number): IPaginatorResult {

    let page = currentPage || 1;
    let perPage = itemsPerPage || 10;
    let offset = (page - 1) * perPage;
    let paginatedItems = items.slice(offset).slice(0, itemsPerPage);
    let totalPages = Math.ceil(items.length / perPage);
    let pageNumberArray: Array<number> = Array(totalPages).fill(0).map((_, index) => index + 1);

    return {
      page: page,
      perPage: perPage,
      prePage: page - 1 ? page - 1 : 1,
      nextPage: (totalPages > page) ? page + 1 : totalPages,
      total: items.length,
      totalPages: totalPages,
      data: paginatedItems,
      pageNumberArray: pageNumberArray
    };

  }

  static setCell(xlsx: any, sheet: number, row: number, col: number, value: string | number, backgroundColor: string = ''): void {
    const cell = xlsx.sheet(sheet).row(row).cell(col);
    cell.value(value);
    // cell.style('shrinkToFit', false);

    if (backgroundColor) {

      cell.style('bold', true);
      cell.style('fontColor', 'ffffff');
      cell.style('fill', backgroundColor);

    }

  }

  static deleteEmptyProperties(obj: any): any {

    const keys = Object.keys(obj);

    if (!keys.length) {
      return undefined;
    }

    for (const key of keys) {

      if (obj.hasOwnProperty(key)) {

        const p = obj[key];

        if (!p) {
          delete obj[key];
        } else {

          if (typeof p === 'object') {
            obj[key] = this.deleteEmptyProperties(p);
            if (!obj[key]) {
              delete obj[key];
            }
          }

        }

      }

    }

    return Object.keys(obj).length ? obj : undefined;

  }

  static reportArray(): Array<Report> {

    const ids = [
      'a', 'b', 'c',
      'd', 'e', 'f',
      'g', 'h', 'i',
      'j', 'k', 'l',
      'm', 'n', 'o',
      'p', 'q', 'r',
      's', 't', 'u',
      'v', 'w', 'x',
      'y', 'z', '1',
      '2', '3', '4',
      '5', '6', '7',
      '8', '9', '0'
    ];

    const reportArray = ids.map(id => new Report({reportID: id}));

    return reportArray;

  }

  static checkBoxTableHolder(array: Array<Base>): Array<{checked: boolean, baseObj: any}> {

    const result = array.map(b => {
      return {checked: false, baseObj: b};
    });

    return result;

  }

}
